import { render } from "./noticeManagement.vue?vue&type=template&id=70fc74fe"
import script from "./noticeManagement.vue?vue&type=script&lang=js"
export * from "./noticeManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__